import { render } from "./PlayoutFilesUploadedTab.vue?vue&type=template&id=1e818b9d"
import script from "./PlayoutFilesUploadedTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutFilesUploadedTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayoutV2/PlayoutFilesUploadedTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e818b9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e818b9d', __exports__)) {
    api.reload('1e818b9d', __exports__)
  }
  
  module.hot.accept("./PlayoutFilesUploadedTab.vue?vue&type=template&id=1e818b9d", () => {
    api.rerender('1e818b9d', render)
  })

}


export default __exports__